module.exports = __webpack_public_path__ + "img/The Democratic Republic of the Congo.3f71f780.gif";